<template>
  <div class="services" v-if="serviceCenters && serviceCenters.length && selectedUserLocation">
    <vue-map
      :spots-list="filteredServiceCenters"
      @dragstart="dragStart"
      @dragend="dragEnd"
      :filtered-shops-by-city="filteredServiceCentersByCity"
      without-list
      is-services
    >
      <template v-slot:filters>
        <shops-filter :spotsInfo="filteredServiceCenters" hot-update-filters is-services toggle-map-list />
      </template>
    </vue-map>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { sortDeliverySpotsByDistance } from '@/mixins'
import VueMap from '@/components/map/VueMap'
import ShopsFilter from '@/components/shops/ShopsFilter'

export default {
  name: 'Services',
  components: {
    VueMap,
    ShopsFilter
  },
  mixins: [sortDeliverySpotsByDistance],
  computed: {
    ...mapState({
      language: state => state.translation.language,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      serviceCenters: state => state.shops.serviceCenters,
      filters: state => state.shops.filters,
      selectedCityOnShops: state => state.shops.selectedCity,
      isShowFiltersModal: state => state.shops.isShowFiltersModal
    }),
    cityNameByLanguage () {
      return this.selectedUserLocation?.['name']
    },
    filteredServiceCenters () {
      let result = this.serviceCenters

      for (let item in this.filters) {
        if (this.filters.hasOwnProperty(item)) {
          if (Array.isArray(this.filters[item])) {
            const arr = []

            this.serviceCenters.forEach(service => {
              if (this.filters[item].every(item => service.services.map(service => service.key).includes(item))) {
                arr.push(service)
              }
            })

            result = arr
          } else {
            result = result.filter(shop => shop[item])
          }
        }
      }

      return this.distanceFilter(result, this.selectedCityOnShops, true)
    },
    filteredServiceCentersByCity () {
      return this.filteredServiceCenters.filter(item => item.cityId.toString() === this.selectedCityOnShops.city_id)
    }
  },
  methods: mapActions(['GET_SERVICES', 'SET_SHOPS_FILTERS_FROM_URL_ACTION', 'SET_SELECTED_CITY_ACTION']),
  created () {
    this.SET_SHOPS_FILTERS_FROM_URL_ACTION()
  },
  mounted () {
    this.GET_SERVICES()
  },
  watch: {
    selectedUserLocation: {
      immediate: true,
      handler (value) {
        this.SET_SELECTED_CITY_ACTION({ ...value, name: this.cityNameByLanguage })
      }
    }
  }
}
</script>

<style scoped lang="sass">
.services__change-spots-btn
  width: 45%
  background: white
  color: #333333
  border: 1px solid #333333
  border-radius: 3px
  padding: 15px 0
  transition: .3s

  &:hover
    background: #333333
    color: white

.tabs-content__text-container
  display: flex
  justify-content: space-around
  margin-bottom: 40px
</style>
